'use client'
import { useMemo } from 'react'
import { RaContainer, RaHeading, RaPaper } from '@components/core/index.core'
import { RaButtonAddToCart } from '@components/features/RaButtonAddToCart/RaButtonAddToCart'
import clsx from 'clsx'

import { unescapeHTML } from '@utilities/helpers/unescape-html.helpers'
import { useScrollPosition } from '@utilities/hooks/useScrollPosition.hooks'

import styles from './ra-product-sticky-footer.module.scss'

const SCROLL_THRESHOLD = 1000

export const RaProductStickyFooter = ({ item }) => {
  const { scrollY } = useScrollPosition()

  const classes = useMemo(() => {
    return clsx(
      styles['ra-product-sticky-footer'],
      scrollY > SCROLL_THRESHOLD && styles['ra-product-sticky-footer--active']
    )
  }, [scrollY])
  return (
    <div className={classes}>
      <RaPaper>
        <RaContainer>
          <div className={styles['ra-product-sticky-footer__content']}>
            <RaHeading
              component="h4"
              noPadding>
              {unescapeHTML(item.title.rendered)}
            </RaHeading>
            <RaButtonAddToCart item={item} />
          </div>
        </RaContainer>
      </RaPaper>
    </div>
  )
}
